module.exports = __webpack_public_path__ + "img/login_bg.1dd69a7c.gif";